import * as React from "react";
import { SVGProps } from "react";
const SvgForward = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m6.25 9.12 8.666 5.004a2.167 2.167 0 0 1 0 3.751L6.25 22.88A2.166 2.166 0 0 1 3 21.003V10.996A2.166 2.166 0 0 1 6.25 9.12Zm13 0 8.667 5.004a2.167 2.167 0 0 1 0 3.751L19.25 22.88A2.165 2.165 0 0 1 16 21.003V10.996a2.165 2.165 0 0 1 3.25-1.877v.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgForward;
